var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5674 6.43718C22.2698 6.13951 21.7861 6.13951 21.4884 6.43718L12 15.9442L2.49303 6.43718C2.19536 6.13951 1.71163 6.13951 1.41396 6.43718C1.11629 6.73486 1.11629 7.21858 1.41396 7.51625L11.4419 17.5442C11.5907 17.693 11.7768 17.7674 11.9814 17.7674C12.1674 17.7674 12.3721 17.693 12.5209 17.5442L22.5488 7.51625C22.8651 7.21858 22.8651 6.73486 22.5674 6.43718Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.a3373635e75fd534778c0821c73c56c4.svg";
export { ForwardRef as ReactComponent };